import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Form, Formik } from "formik";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { hooks } from "../hooks";
import { components } from "../components";
import AuthLayout from "../services/auth/jwt/withAuth";
import { showErrorToast, showSuccessToast } from "../components/apps/AppError";
import { APP_ROUTES } from "../constants/app_routes";
import { UPDATE_WITHDRAW_PASSWORD } from "../graphql/mutations/profile";
import { AppSubmitButton, AppTextField } from "../components/apps";
import { useQueryProfile } from "../graphql/apollo/useQuery";

export const WithdrawPasswordScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigate = hooks.useNavigate();
  const { myProfile, refetch } = useQueryProfile();
  const havePassword = myProfile?.withdrawPassword;
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const validationSchema = yup.object({
    amount: yup.number(),
  });

  const [updateWithdrawPassword, { loading }] = useMutation(
    UPDATE_WITHDRAW_PASSWORD,
    {
      onCompleted: (data) => {
        if (data.updateWithdrawPassword) {
          showSuccessToast();
          navigate(APP_ROUTES.PROFILE);
          refetch();
        }
      },
      onError: (err) => {
        showErrorToast(err.message);
      },
    }
  );

  const handleSubmit = (data: any) => {
    updateWithdrawPassword({
      variables: {
        input: {
          oldPassword: data.oldPassword,
          password: data.password,
          passwordConfirm: data.passwordConfirm,
        },
      },
    });
  };

  return (
    <AuthLayout>
      <components.Header goBack title={t("updateWithdrawPassword")} />
      <main
        className="container"
        style={{ paddingTop: "14%", paddingBottom: 20 }}
      >
        <div
          className="custom-block"
          style={{ padding: 20, marginTop: 20, marginBottom: 10 }}
        >
          <Formik
            validateOnChange
            initialValues={{ amount: 0 }}
            onSubmit={(data: any) => handleSubmit(data)}
            validationSchema={validationSchema}
          >
            {() => (
              <Form noValidate autoComplete="off">
                {havePassword && (
                  <AppTextField
                    placeholder={t("oldPassword")}
                    name="oldPassword"
                    label={t("oldPassword")}
                  />
                )}
                <AppTextField
                  placeholder={t("newPassword")}
                  name="password"
                  label={t("newPassword")}
                />
                <AppTextField
                  placeholder={t("confirmNewPassword")}
                  name="passwordConfirm"
                  label={t("confirmNewPassword")}
                />
                <AppSubmitButton
                  label={t("confirm")}
                  disabled={false}
                  loading={loading}
                />
              </Form>
            )}
          </Formik>
        </div>
      </main>
    </AuthLayout>
  );
};
